import axios from 'axios';
import * as actions from './actionsTypes';
import messages from '../../messages';
import DashboardRespBossServices from './dashboardJefeResp.services';

export const getDashBoardRespBoss = (filters) => async dispatch => {
  try {
    dispatch({
      type: actions.LOADING_DASHBOARD_RESPONSIBLE_BOX,
      payload: true
    });

    const resp = await DashboardRespBossServices.getDashboardRespBox(filters);
    const oData = resp.data;
    oData.dataset[0].backgroundColor = '#0070b8';
    oData.dataset[0].hoverBackgorundColor = '#0070b8';
    oData.dataset[1].backgroundColor = '#e48100';
    oData.dataset[1].hoverBackgorundColor = '#e48100';
    oData.dataset[2].backgroundColor = 'grey';
    oData.dataset[2].hoverBackgorundColor = 'grey';
    dispatch({
      type: actions.GET_DASHBOARD_RESPONSIBLE_BOX,
      payload: oData
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.DASHBOARD_ERROR,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_DASHBOARD_RESPONSIBLE_BOX,
      payload: false
    });
  }
}